import React, { useState } from 'react';
import TablePicker from './components/TablePicker';
import TableBrowser from './components/TableBrowser';
import SyncStatus from './components/SyncStatus';
import { useDbExplorerTables } from './hooks/useDbExplorer';
import './DbExplorerApp.css';

const DbExplorerApp = () => {
  const { tables, loading: tablesLoading, error: tablesError } = useDbExplorerTables();
  const [selected, setSelected] = useState(null); // { schema, name }
  const [view, setView] = useState('tables');     // 'tables' | 'sync'

  const picker = (
    <TablePicker tables={tables} value={selected} onChange={setSelected} />
  );
  const viewToggle = (
    <div className="btn-group btn-group-sm db-explorer-view-switch" role="group">
      <button type="button" className={`btn btn-sm ${view === 'tables' ? 'btn-secondary' : 'btn-outline-light'}`} onClick={() => setView('tables')}>Tables</button>
      <button type="button" className={`btn btn-sm ${view === 'sync' ? 'btn-secondary' : 'btn-outline-light'}`} onClick={() => setView('sync')}>Sync status</button>
    </div>
  );

  if (view === 'sync') {
    return (
      <div className="db-explorer-app">
        <div className="db-explorer-toolbar">{viewToggle}<span className="db-explorer-row-info">public.sync_log, written by scripts/sync_to_cloud.py</span></div>
        <SyncStatus />
      </div>
    );
  }

  return (
    <div className="db-explorer-app">
      {tablesError && (
        <div className="alert alert-danger db-explorer-alert">Failed to load tables: {tablesError}</div>
      )}

      {!selected ? (
        <>
          <div className="db-explorer-toolbar">{viewToggle}{picker}</div>
          <div className="db-explorer-placeholder">
            {tablesLoading ? 'Loading tables…' : 'Pick a table to browse.'}
          </div>
        </>
      ) : (
        <TableBrowser
          key={`${selected.schema}.${selected.name}`}
          schema={selected.schema}
          table={selected.name}
          picker={<>{viewToggle}{picker}</>}
        />
      )}
    </div>
  );
};

export default DbExplorerApp;
